import { render, staticRenderFns } from "./allJoin.vue?vue&type=template&id=ab52b192&scoped=true&"
import script from "./allJoin.vue?vue&type=script&lang=js&"
export * from "./allJoin.vue?vue&type=script&lang=js&"
import style0 from "./allJoin.vue?vue&type=style&index=0&id=ab52b192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab52b192",
  null
  
)

export default component.exports